import config from "../../../config/config";
import { authFetch, buildAuthHeaders } from "../../../public/api/httpClient";

const getRenewalsBase = () => {
  return `${config.BASE_URL}/membership-control/membership-renewals`;
};


async function parseJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid response" };
  }
}

function messageForResponse(res, payload, fallback) {
  if (res.status >= 500) return "Internal server error. Please try again later.";
  const m = payload?.message;
  return typeof m === "string" && m.trim() ? m : fallback;
}

export const fetchMembershipRenewals = async (params = {}) => {
  const queryParams = new URLSearchParams();
  if (params.page) queryParams.append("page", String(params.page));
  if (params.limit) queryParams.append("limit", String(params.limit));
  if (params.sortBy) queryParams.append("sortBy", params.sortBy);
  if (params.sortOrder) queryParams.append("sortOrder", params.sortOrder);

  const queryString = queryParams.toString();
  const res = await authFetch(`${getRenewalsBase()}${queryString ? `?${queryString}` : ""}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(messageForResponse(res, data, "Failed to fetch renewals"));
  return {
    renewals: data.data || [],
    meta: data.meta || { total: 0, page: 1, limit: 10, totalPages: 1 },
  };
};

export const fetchRenewalById = async (renewalId) => {
  const res = await authFetch(`${getRenewalsBase()}/${encodeURIComponent(String(renewalId))}`, {
    credentials: "include",
    headers: buildAuthHeaders(),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(messageForResponse(res, data, "Failed to fetch renewal details"));
  return data.data;
};

export const verifyRenewal = async (renewalId, body = {}, csrfToken) => {
  const res = await authFetch(
    `${getRenewalsBase()}/${encodeURIComponent(String(renewalId))}/verify`,
    {
      method: "PATCH",
      credentials: "include",
      headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
      body: JSON.stringify(body),
    },
  );
  const data = await parseJson(res);
  if (!res.ok) throw new Error(messageForResponse(res, data, "Failed to update renewal verification"));
  return data;
};

export const deleteRenewal = async (renewalId, csrfToken) => {
  const res = await authFetch(`${getRenewalsBase()}/${encodeURIComponent(String(renewalId))}`, {
    method: "DELETE",
    credentials: "include",
    headers: buildAuthHeaders(csrfToken ? { "X-CSRF-Token": csrfToken } : {}),
  });
  const data = await parseJson(res);
  if (!res.ok) throw new Error(messageForResponse(res, data, "Failed to delete renewal"));
  return data;
};
